// removed by extract-text-webpack-plugin
module.exports = {"RouteNotFound":"src-components-App-___RouteNotFound__RouteNotFound___3DWry","top":"src-components-App-___RouteNotFound__top___mHMq2","homeButton":"src-components-App-___RouteNotFound__homeButton___1xFP-","backArrow":"src-components-App-___RouteNotFound__backArrow___uvqXF","logo":"src-components-App-___RouteNotFound__logo___1OHWp","container":"src-components-App-___RouteNotFound__container___2v7ew","mainText":"src-components-App-___RouteNotFound__mainText___2wWSP","subText":"src-components-App-___RouteNotFound__subText___1U7CV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/RouteNotFound.css
// module id = 1211
// module chunks = 3